import React, { useState, useEffect } from 'react';
import { getTeamLogo } from '../utils/teamUtils';

const TeamMatchupIndicator = ({ players, season, team, selectedStat }) => {
  // Simple placeholder for TeamMatchupIndicator
  return (
    <span className="text-gray-600 dark:text-gray-400">Neutral</span>
  );
};

const PlayerHeader = ({ 
  player, 
  mostRecentGame, 
  fullName, 
  team, 
  position, 
  matchupRating, 
  selectedMatchId, 
  fixtures,
  playerImage
}) => {
  // Add state to track image loading status
  const [imageLoaded, setImageLoaded] = useState(true);
  
  // Reset image loading state when player changes
  useEffect(() => {
    setImageLoaded(true);
  }, [playerImage, fullName]);
  
  if (!player) return null;
  
  // Get player initials for the fallback display
  const initials = fullName
    .split(' ')
    .map(n => n[0])
    .join('');
  
  return (
    <div className="mb-2">
      <div className="flex flex-col space-y-4">
        {/* Player Info and Buttons Container */}
        <div className="flex flex-col lg:flex-row items-start gap-4 w-full">
          {/* Player Info */}
          <div className="flex items-center w-full lg:w-auto">
            <div className="w-24 h-24 flex-shrink-0 flex items-center justify-center overflow-hidden mr-4 bg-gray-100 dark:bg-gray-700 rounded-full">
              {playerImage && imageLoaded ? (
                <img 
                  src={playerImage}
                  alt={fullName}
                  className="w-full h-full object-contain"
                  onError={() => {
                    // Just set the state instead of modifying the DOM directly
                    setImageLoaded(false);
                  }}
                />
              ) : (
                <span className="text-xl text-gray-600 dark:text-gray-300">
                  {initials}
                </span>
              )}
            </div>
            <div className="min-w-0">
              <div className="flex flex-wrap items-center gap-x-2 gap-y-1">
                <h1 className="text-2xl font-bold text-gray-900 dark:text-white leading-7 break-words min-w-[150px]">{fullName}</h1>
              </div>
              <div className="flex items-center text-gray-600 dark:text-gray-400 flex-wrap gap-1.5">
                <img 
                  src={getTeamLogo(player.player_team)}
                  alt={player.player_team}
                  className="w-5 h-5"
                />
                <span>{position}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PlayerHeader; 